var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"page-intro"},[_c('h1',{staticClass:"heading-1",domProps:{"innerHTML":_vm._s(_vm.heading)}}),(_vm.body.length > 0)?_c('div',{staticClass:"intro",domProps:{"innerHTML":_vm._s(_vm.body)}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }